import React from 'react';
import logo from './logo.svg';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link
} from "react-router-dom";
import Login from './component/login/login'
import Users from './component/users/users'
import User from './component/users/user'
import Count from './component/count/count'
import Entry from './component/other/entry'
import Output from './component/other/output'
import Noaccred from './component/other/noaccred'
import Matchs from './component/matchs/matchs'
import Match from './component/matchs/match'
import Accreditation from './component/accreditation/accreditation'
import TrainingForm from './component/trainingForm/trainingForm'
import CreditForm from './component/creditForm/creditFrom'
import AdherentForm from './component/adherentForm/adherentForm'
import Agenda from './component/agenda/agenda'


import Tournaments from './component/tournament/tournaments'
import Tournament from './component/tournament/tournament'
import CreateTournament from './component/tournament/createTournament'
import Dashboard from './component/dashboard/dashboard'
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, Form, FormControl, Button } from 'react-bootstrap';


const fakeAuth = {
  isAuthenticated: false,
  authenticate(cb) {
    this.isAuthenticated = true
    setTimeout(cb, 100)
  },
  signout(cb) {
    this.isAuthenticated = false
    setTimeout(cb, 100)
  }
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    localStorage.getItem('web_bm')
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
)

export default function App() {
  return (
    <Router>
      {
        window.location.href.indexOf('/freeAgenda') == -1  &&
        <Navbar bg="dark" variant="dark">
          <Navbar.Brand href="#home">BeachMasters</Navbar.Brand>
          <Nav className="mr-auto">
            {!localStorage.getItem('web_bm') &&
              <Nav.Link href="/login">Login</Nav.Link>
            }
            {localStorage.getItem('web_bm') &&
              <>
                <Nav.Link href="/">Dashboard</Nav.Link>
                <Nav.Link href="/tournaments">Tournament</Nav.Link>
                <Nav.Link href="/users">Utilsateurs</Nav.Link>
                <Nav.Link href="/agenda">Agenda</Nav.Link>
                <Nav.Link href="/addEntrainement">Bloquer un créneau</Nav.Link>
                <Nav.Link href="/addCredit">Crédit</Nav.Link>
                <Nav.Link href="/adherent">Adhérent</Nav.Link>



              </>
            }
            <Nav.Link href="/count">Compteur</Nav.Link>
        <Nav.Link href="/accreditation">Accréditation</Nav.Link>


          </Nav>

        </Navbar>
      }
      <Switch>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route path="/about">
          <About />
        </Route>

        <PrivateRoute path='/tournaments' component={Tournaments} />
        <Route path='/count' component={Count} />
        <Route path='/message/entry' component={Entry} />
        <Route path='/message/output' component={Output} />   
        <Route path='/message/noaccred' component={Noaccred} />
        <Route path='/accreditation' component={Accreditation} />
        <PrivateRoute path='/users' component={Users} />
        <Route path='/matchs' component={Matchs} />
        <Route path='/match/:id' component={Match} />
        <Route path='/freeAgenda' component={Agenda} />



        <PrivateRoute path='/tournament/create' component={CreateTournament} />
        <PrivateRoute path='/tournament/:id' component={Tournament} />
        <PrivateRoute path='/users' component={Users} />
        <PrivateRoute path='/user/:id' component={User} />
        <PrivateRoute path='/addEntrainement' component={TrainingForm} />
        <PrivateRoute path='/addCredit' component={CreditForm} />
        <PrivateRoute path='/adherent' component={AdherentForm} />
        <PrivateRoute path='/agenda'>
          <Agenda admin={true} />
        </PrivateRoute>




        <PrivateRoute path='/' component={Dashboard} />
      </Switch>
    </Router>
  );
}



function About() {
  return (
    <div>
      <h2>About</h2>
    </div>
  );
}

